import { useMemo } from 'react'
import { Navigate, useNavigate, useParams } from 'react-router-dom'

import {
  FBPageInnerTabsContainer,
  FBPageTableContainer,
} from 'components/FbUI/Page/styles'
import { Tabs } from 'components/FbUI/Tabs'
import { Account } from 'features/settings/components/Account'
import { Logo } from 'features/settings/components/Logo'
import { CompanyDomainsTable } from 'features/settings/components/CompanyDomainsTable'
import { useAuth } from 'context/authentication/useAuth'
import { useFeatureFlagService } from 'utils/useFeatureFlagService'

export function CompanySettingsPage() {
  const params = useParams()
  const navigate = useNavigate()
  const { user, isAllowed } = useAuth()
  const featureFlags = useFeatureFlagService()
  const isReadOnly = !isAllowed('Admin')

  const tabs = useMemo(() => {
    const allTabs: { key: string; title: string }[] = []

    if (user?.is_billing_admin) {
      allTabs.push({ key: 'account', title: 'Account' })
    }

    allTabs.push({ key: 'logo', title: 'Logo' })

    if (featureFlags.enableCompanyEmailExtensionSettings) {
      allTabs.push({ key: 'domains', title: 'Domains' })
    }

    return allTabs
  }, [user?.is_billing_admin, featureFlags.enableCompanyEmailExtensionSettings])

  const defaultTab = tabs[0]?.key ?? 'account'
  const tab = params.tab ?? defaultTab

  if (params.tab && !tabs.some((t) => t.key === params.tab)) {
    return <Navigate to={`/settings/company/${defaultTab}`} replace />
  }

  return (
    <div className="w-full h-full flex flex-col flex-1 min-h-0">
      <FBPageInnerTabsContainer>
        <Tabs
          tabs={tabs}
          selectedTab={tab}
          setSelectedTab={(value) => navigate(`/settings/company/${value}`)}
          tabStyle={{ width: '125px' }}
        />
      </FBPageInnerTabsContainer>
      <FBPageTableContainer hide={tab !== 'account'}>
        <Account disabled={isReadOnly} />
      </FBPageTableContainer>
      <FBPageTableContainer hide={tab !== 'logo'}>
        <Logo disabled={isReadOnly} />
      </FBPageTableContainer>
      <FBPageTableContainer hide={tab !== 'domains'}>
        <CompanyDomainsTable disabled={isReadOnly} />
      </FBPageTableContainer>
    </div>
  )
}
